export enum PreCheckinTrainingStateActionTypes {
  IsTrainingReady = '[IsTrainingReady] action',
  GetTrainingCenterConfiguration = '[GetTrainingCenterConfiguration] action',
  GetTraining = '[GetTraining] action',
  GetCurrentTraining = '[GetCurrentTraining] action',
  GetTrainingCenter = '[GetTrainingCenter] action'
}

export class IsTrainingReady {
  public static readonly type =
    PreCheckinTrainingStateActionTypes.IsTrainingReady;
  constructor(public payload: boolean) {}
}

export class GetTrainingCenterConfiguration {
  public static readonly type =
    PreCheckinTrainingStateActionTypes.GetTrainingCenterConfiguration;

  constructor(public geminiSiteId: string) {}
}

export class GetTraining {
  public static readonly type = PreCheckinTrainingStateActionTypes.GetTraining;
  constructor(public id: string) {}
}

export class GetCurrentTraining {
  public static readonly type =
    PreCheckinTrainingStateActionTypes.GetCurrentTraining;
}

export class GetTrainingCenter {
  public static readonly type =
    PreCheckinTrainingStateActionTypes.GetTrainingCenter;

  constructor(public geminiSiteId: string) {}
}
